// extracted by extract-css-chunks-webpack-plugin
module.exports = {"tab":"tab-2O4sC"};